import i18next from 'i18next';
import moment from 'moment';
import 'moment/min/locales';

moment.locale(i18next.language);

export default moment;
